import React from "react";
import './style.css'

function Botao({ texto, onClick, href }) {
    return (
        <button className="botao" onClick={onClick} href >{texto}</button>
    )
}

export default Botao